import React, { useState } from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import DateRangePickerML from '@/components/DateRangePickerML';
import {
  useTheme,
  Box,
  Button,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import dayjs from 'dayjs';

const SearchCondition = (props) => {
  const theme = useTheme();
  // 控制日期控件的重置
  const [isResetDefalut, setIsResetDefalut] = useState(false);
  const { query, handleSearch, restClick } = props;
  const { baseDateStart, baseDateEnd } = query;
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      date: { startDate: baseDateStart, endDate: baseDateEnd },
    },
  });

  //   搜索
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
      ...query,
      baseDateStart: submitData.date?.startDate ?? baseDateStart,
      baseDateEnd: submitData.date?.endDate ?? baseDateEnd,
      isSearch: true,
    };
    delete propsSubmitData.date;
    handleSearch && handleSearch(propsSubmitData);
  };
  //   重置
  const resetData = () => {
    const resetSearch = {
      date: {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      },
    };
    setValue('date', resetSearch);
    setIsResetDefalut(true);
    const propsResetSearch = {
      ...query,
      isSearch: true,
      baseDateEnd: dayjs().format('YYYY-MM-DD'),
      baseDateStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    };
    restClick && restClick(propsResetSearch);
  };
  // 日期为空校验
  const isDataValid =
    getValues('date')?.startDate === null ||
    getValues('date')?.endDate === null;

  // 日期超过30天校验
  const dateDiffValid =
    dayjs(getValues('date')?.endDate).diff(
      dayjs(getValues('date')?.startDate),
      'day',
    ) > 30;

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="search_condition">
          <div className="condition_wrap">
            <FormControl variant="standard" className="date_range">
              <Controller
                render={(rp) => (
                  <DateRangePickerML
                    startText={'开始日期'}
                    endText={'结束日期'}
                    afterDays={30}
                    resetStartDate={dayjs()
                      .subtract(30, 'day')
                      .format('YYYY-MM-DD')}
                    defaultStartDate={
                      baseDateStart === undefined
                        ? dayjs().subtract(30, 'day').format('YYYY-MM-DD')
                        : baseDateStart
                    }
                    defaultEndDate={
                      baseDateEnd === undefined
                        ? dayjs().format('YYYY-MM-DD')
                        : baseDateEnd
                    }
                    rp={rp}
                    onChange={({ startDate, endDate }) => {
                      handleSearch({
                        ...query,
                        isSearch: 'false',
                        baseDateStart: startDate,
                        baseDateEnd: endDate,
                      });
                      setIsResetDefalut(false);
                    }}
                    name="custom-form-submit-name"
                    isResetDefalut={isResetDefalut}
                  />
                )}
                name="date"
                control={control}
                rules={{
                  validate: () => {
                    const status = !(
                      getValues('date').startDate === null ||
                      getValues('date').endDate === null
                    );
                    const dateStatus = dayjs(getValues('date')?.endDate).diff(
                      dayjs(getValues('date')?.startDate),
                      'day',
                    );
                    return dateStatus < 31 && status;
                  },
                }}
              />
              <FormHelperText error={Boolean(isDataValid)}>
                {isDataValid && '日期不能为空'}
              </FormHelperText>
              <FormHelperText error={Boolean(dateDiffValid)}>
                {dateDiffValid && '日期间隔不得大于31天'}
              </FormHelperText>
            </FormControl>
          </div>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>
            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
